/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useT } from 'talkr';
import Interval from '../../../../utils/scripts/interval';
import s from './sliderReview.module.scss';

import stars from '../img/stars.svg';

let currentInterval;

function Slide({
  review, index, currentSlide, sliderCounts,
}) {
  const { T } = useT();
  const title = T(`${review.name}_title`);
  const name = T(`${review.name}_name`);
  const description = T(`${review.name}_description`);
  const isItFirstSlide = index === 0;
  const isItLastSlide = index === sliderCounts - 1;
  const isItCurrentSlide = index === currentSlide;
  const isItPreviousSlide = ((currentSlide - 1) === index);
  const isItNextSlide = ((currentSlide + 1) === index);

  const currentSlideClassName = isItCurrentSlide ? s.currentSlide : '';
  const previousSlideClassName = isItPreviousSlide ? s.previousSlide : '';
  const nextSlideClassName = isItNextSlide ? s.nextSlide : '';

  return (
    <>
      {isItFirstSlide && <div className={s.firstSlide} />}
      <li className={`${s.sliderSlide} ${currentSlideClassName} ${previousSlideClassName} ${nextSlideClassName}`}>
        <div className={s.sliderSlideTop}>
          <div className={s.sliderSlideTopText}>
            <div className={s.sliderSlideTopTextName}>{title}</div>
            <div className={s.sliderSlideTopTextRecomends}>{name}</div>
          </div>
        </div>
        <div className={s.sliderSlideStars}>
          <img src={review.starsImg ? review.starsImg : stars} alt={stars} />
        </div>
        <div className={s.sliderSlideBottom}>{description}</div>
      </li>
      {isItLastSlide && <div className={s.lastSlide} />}
    </>
  );
}

function SliderReview() {
  let [currentSlide, setCurrentSlide] = useState(0);

  const reviews = [
    {
      name: 'loader_review_0',
    },
    {
      name: 'loader_review_1',
    },
    {
      name: 'loader_review_2',
    },
  ];

  useEffect(() => {
    currentInterval = new Interval(() => {
      if (currentSlide >= reviews.length) {
        currentInterval.stop();
        return;
      }

      setCurrentSlide(currentSlide++);
    }, 3500);

    currentInterval.run();
  }, []);

  useEffect(() => () => {
    currentInterval.stop();
  }, []);

  return (
    <div className={s.slider}>
      <div className={s.sliderTrack} data-glide-el="track">
        <ul className={s.sliderSlides}>
          {
            reviews.map((review, index) => (
              <Slide review={review} index={index} key={review.name} currentSlide={currentSlide} sliderCounts={reviews.length} />
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default SliderReview;
